import { Eye } from 'lucide-react'
import { Link } from 'react-router-dom'

import { formatearFechaGasto, formatearMontoGasto } from '../../utils/gastos'

function UltimosMovimientos({ movimientos, onVer }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white shadow-sm">
      <div className="flex flex-wrap items-center justify-between gap-4 border-b border-slate-200 p-6">
        <div>
          <h3 className="text-lg font-bold text-slate-900">
            Últimos movimientos
          </h3>

          <p className="mt-1 text-sm text-slate-500">
            Ingresos y gastos más recientes de la empresa.
          </p>
        </div>

        <div className="flex gap-4">
          <Link
            to="/ingresos"
            className="text-sm font-semibold text-emerald-700 hover:text-emerald-800"
          >
            Ver ingresos
          </Link>

          <Link
            to="/gastos"
            className="text-sm font-semibold text-emerald-700 hover:text-emerald-800"
          >
            Ver gastos
          </Link>
        </div>
      </div>

      {movimientos.length === 0 ? (
        <p className="p-6 text-sm text-slate-500">
          Aún no hay movimientos registrados.
        </p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm md:min-w-[780px]">
            <thead className="bg-slate-50 text-xs font-semibold uppercase tracking-wide text-slate-500">
              <tr>
                <th className="px-6 py-3">Fecha</th>
                <th className="hidden px-6 py-3 md:table-cell">
                  Tipo
                </th>
                <th className="px-6 py-3">Cliente / Proveedor</th>
                <th className="hidden px-6 py-3 md:table-cell">
                  Descripción
                </th>
                <th className="px-6 py-3 text-right">Monto</th>
                <th className="px-6 py-3 text-right">Ver</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-100">
              {movimientos.map((movimiento) => {
                const esIngreso = movimiento.tipo === 'ingreso'

                return (
                  <tr key={`${movimiento.tipo}-${movimiento.id}`}>
                    <td className="whitespace-nowrap px-6 py-3 text-slate-600">
                      {formatearFechaGasto(movimiento.fecha)}
                    </td>

                    <td className="hidden whitespace-nowrap px-6 py-3 md:table-cell">
                      <span
                        className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ${
                          esIngreso
                            ? 'bg-emerald-100 text-emerald-700'
                            : 'bg-slate-100 text-slate-600'
                        }`}
                      >
                        {esIngreso ? 'Ingreso' : 'Gasto'}
                      </span>
                    </td>

                    <td className="whitespace-nowrap px-6 py-3 text-slate-800">
                      {movimiento.tercero}
                    </td>

                    <td
                      className="hidden max-w-xs truncate px-6 py-3 text-slate-600 md:table-cell"
                      title={movimiento.descripcion}
                    >
                      {movimiento.descripcion}
                    </td>

                    <td
                      className={`whitespace-nowrap px-6 py-3 text-right font-semibold ${
                        esIngreso
                          ? 'text-emerald-600'
                          : 'text-slate-700'
                      }`}
                    >
                      {esIngreso ? '+' : '-'}
                      {formatearMontoGasto(movimiento.monto)}
                    </td>

                    <td className="whitespace-nowrap px-6 py-3 text-right">
                      <button
                        type="button"
                        onClick={() => onVer(movimiento)}
                        title="Ver"
                        aria-label={`Ver ${
                          esIngreso ? 'ingreso' : 'gasto'
                        } ${movimiento.descripcion}`}
                        className="rounded-lg border border-slate-300 p-2 text-slate-600 transition hover:bg-slate-100"
                      >
                        <Eye size={16} />
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

export default UltimosMovimientos
